<template>
  <div class="text-wrapper">
    <p class="district">{{ displayName }}</p>
    <p
      class="cases"
      :style="textStyle"
    >
      <span class="count">
        {{ cases }}
      </span>
      {{ $tc('case', cases) }}
    </p>
  </div>
</template>

<script>
import Vue from "vue";
import i18n from "../i18n";
export default Vue.extend({
  i18n: i18n,
  props: {
    district: {
      required: true,
      type: Boolean
    },
    name: {
      required: true,
      type: String
    },
    name_zh: {
      required: true,
      type: String
    },
    color: {
      required: true,
      type: String
    },
    cases: {
      required: true,
      type: Number
    }
  },
  computed: {
    textStyle() {
      return "color: " + this.color;
    },
    displayName() {
      if (this.district) {
        return this.$t("districts." + this.name);
      } else {
        if (this.$i18n.locale == "en") {
          return this.name;
        } else {
          return this.name_zh;
        }
      }
    }
  }
});
</script>

<style lang="scss" scoped>
.text-wrapper {
  display: inline-block;
  padding: 10px;
  font-size: 14px;

  p.district {
    margin: 0;
    font-weight: 700;
    font-family: $type-normal;
    color: $hku-black;
    line-height: 1.4;
  }
  p.cases {
    margin: 0;
    line-height: 1.4;
    font-weight: 600;
    font-family: $type-number;

    span.count {
      font-weight: 800;
    }
  }
}
</style>
